import { useEffect, useRef, useState } from "react";

/**
 * `on` as a loading cue: it turns true only after `delayMs` (so fast loads never flash it)
 * and then stays true for at least `minMs` (so it never blinks).
 */
export function useDelayedFlag(on: boolean, delayMs = 200, minMs = 300) {
  const [shown, setShown] = useState(false);
  const shownAt = useRef(0);

  useEffect(() => {
    if (on) {
      if (shown) return;
      const timer = setTimeout(() => {
        shownAt.current = Date.now();
        setShown(true);
      }, delayMs);
      return () => clearTimeout(timer);
    }
    if (!shown) return;
    const timer = setTimeout(
      () => setShown(false),
      Math.max(0, shownAt.current + minMs - Date.now()),
    );
    return () => clearTimeout(timer);
  }, [on, shown, delayMs, minMs]);

  return shown;
}
